__turbopack_context__.v({
  "playIcon": "_4FvD2W_playIcon",
  "video": "_4FvD2W_video",
});
